/**
 * Error Redirect Plugin
 *
 * Intercepts 404/400 errors before they reach the error page and redirects to helpful pages.
 * This prevents the error page from flashing before redirect.
 */
// import { useRedirectHelpers } from '@/composables/useRedirectHelpers'

export default defineNuxtPlugin(async () => {
    // nuxtApp.hook('app:error', async (error) => {
    //     const { handleErrorRedirect } = useRedirectHelpers()
    //     const route = useRoute()
    //     await handleErrorRedirect(error, route)
    // })
})
